var _circle, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAppIcon = function SvgAppIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 18.9163L22.9223 15.4552C23.2334 15.3385 23.5445 15.4552 23.7001 15.7274C23.8556 15.9996 23.739 16.3496 23.4667 16.5052L16.2723 20.083C16.1167 20.1608 15.9223 20.1608 15.7278 20.083L8.57229 16.5441C8.30007 16.3885 8.18341 16.0385 8.33896 15.7663C8.49452 15.4941 8.84452 15.3385 9.11674 15.4941L16.0001 18.9163Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 22.4945L22.9224 19.0334C23.2335 18.9167 23.5446 19.0334 23.7002 19.3056C23.8557 19.5778 23.7391 19.9278 23.4669 20.0834L16.2724 23.6611C16.1169 23.7389 15.9224 23.7389 15.728 23.6611L8.57241 20.1223C8.30019 19.9667 8.18352 19.6167 8.33908 19.3445C8.49463 19.0723 8.84463 18.9167 9.11686 19.0723L16.0002 22.4945ZM8.57241 12.9278C8.33908 12.85 8.22241 12.6556 8.22241 12.4223C8.22241 12.1889 8.33908 11.9945 8.57241 11.8778L15.7669 8.30003C15.9224 8.22225 16.1169 8.22225 16.3113 8.30003L23.5057 11.8778C23.7002 11.9945 23.8557 12.1889 23.8557 12.4223C23.8557 12.6556 23.7391 12.85 23.5057 12.9667L16.3113 16.5445C16.1557 16.6223 15.9613 16.6223 15.7669 16.5445L8.57241 12.9278ZM16.0002 15.3389L21.8335 12.4223L16.0002 9.50559L10.1669 12.4223L16.0002 15.3389Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAppIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/appIcon.fa47d479.svg";
export { ForwardRef as ReactComponent };